/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Paloma = ({ color = 'primary', aspectRatio = '789/137', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Paloma" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Paloma, Paloma as default };
